import { action, observable, makeObservable } from 'mobx';
import ProjectsStore from './ProjectsStore';
import WorkflowInstanceStore from './WorkflowInstanceStore';

export default class FileOperationsStore {
    isNewContractModalVisibile: boolean = false;

    isSessionProgressDialogVisible: boolean = false;

    listenersRegistered: boolean = false;

    constructor(
        public workflowInstanceStore: WorkflowInstanceStore,
        public projectsStore: ProjectsStore
    ) {
        makeObservable(this, {
            isNewContractModalVisibile: observable,
            isSessionProgressDialogVisible: observable,
            setIsFileUploadModalVisibile: action,
            setIsSessionProgressDialogVisible: action
        });
    }

    setIsFileUploadModalVisibile(isVisible: boolean) {
        this.isNewContractModalVisibile = isVisible;
    }

    setIsSessionProgressDialogVisible(isVisible: boolean) {
        this.isSessionProgressDialogVisible = isVisible;
    }
}
